import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { TemplateSectionCreationData } from 'src/company/templates/types';

type SplitMarkdownPayload = {
  templateMarkdown: string;
  populatedMarkdown: string;
  level: number;
};

export default function useSplitMarkdownMutation() {
  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
    data,
  } = useMutation<{ data: TemplateSectionCreationData[] }, Error, SplitMarkdownPayload>({
    mutationFn: values =>
      api.post<TemplateSectionCreationData[]>('admin/templates/split-markdown', values),
  });

  const splitMarkdown = async (values: SplitMarkdownPayload) => {
    const response = await mutateAsync(values);
    return response.data;
  };

  return {
    splitMarkdown,
    error,
    isLoading,
    reset,
    sections: data?.data,
  };
}
